import { getScreenName } from '../../../Utils/helper';

import { fireEvent } from '../../../Utils/fireEvent';

export const fireRecommendedEvent = (searchString) => {
  fireEvent({
    category: 'clicked_recommended_search',
    screen_name: getScreenName(),
    support_variable: decodeURIComponent(searchString),
    content_type: 'product',
  });
};
